export function isAvatarEntry(entry) {
  return entry?.type === "avatar" || entry?.type === "avatar_listing" || entry?.asset_type === "avatar";
}

export function getAvatarIdFromEntry(entry) {
  if (!entry) return null;
  return entry.avatar_id || entry.sid || (isAvatarEntry(entry) ? entry.id : null) || null;
}

export function buildAvatarEntryHref(entry, { persistenceApiUrl } = {}) {
  const avatarId = getAvatarIdFromEntry(entry);
  if (!avatarId || !persistenceApiUrl) return null;

  const baseUrl = String(persistenceApiUrl).trim().replace(/\/+$/, "");
  return `${baseUrl}/avatars/${avatarId}`;
}

export function getAvatarSpawnSrc(entry) {
  return entry?.gltfs?.avatar || entry?.asset_url || entry?.url || null;
}

export function buildAvatarSpawnPayload(entry, opts = {}) {
  const src = getAvatarSpawnSrc(entry);
  const href = buildAvatarEntryHref(entry, opts);
  const mediaOptions = { ...(entry?.mediaOptions || {}) };

  if (href && !mediaOptions.href) {
    mediaOptions.href = href;
  }

  return {
    src,
    mediaOptions
  };
}
